import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step,Dropzone} from '../components/Common';
import {Input,TextButton,Button,Box,MiniMinusButton, PageSelector} from '../components/Input';
import u from '../utilities/Utilities';
import {Photo, Spreadsheet} from '../data/Mimetypes';
import moment from 'moment';

export default class CourseList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"E-Learning Quiz",
        permission:"course",          //Accepts combined permission module as well
        //combinedField:"",   //Used when permission exists in a combined field
        url:"/quiz-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/create-quiz-entries",
        deleteURL:"/api/delete-quiz-entries",
        spreadsheetURL:"/api/generate-quiz-spreadsheet",
        overviewURL:"/api/get-all-quiz-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"quiz-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        languages:[],
    };

    getOptions=async ()=>{
        try{
            const response = await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:["eLearningLanguage"]
                }
            });
            this.setState({
                languages:response.data.eLearningLanguage.map(
                    (item)=>{
                        return item.value
                    }
                )
            });   
        }
        catch(e){
            const {error,status}=u.processError(e);
        }
    }

    componentDidMount=()=>{
        this.getOptions();
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onCloneEntry=(content)=>{
        const {languages}=this.state;
        let clone=JSON.parse(JSON.stringify(content));
        let entryData={
            questions:clone.questions.map((item)=>{
                for(var i=0; i<languages.length; i++){
                    if(typeof item[languages[i]] == 'undefined'){
                        item[languages[i]]={wrong:["","",""]}
                    }
                }
                return item;
            }),
            reference:clone.reference,
        };
        this.r['pageMenu'].toggleForm("add",true);
        this.r['pageMenu'].getRef("add").editEntry(clone,entryData);
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index} 
                                          index={index} 
                                          content={content} 
                                          onChange={onChange} 
                                          onContentChange={onContentChange} 
                                          registerReference={registerRef} 
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          languages={this.state.languages}
                                          onCloneEntry={this.onCloneEntry}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}


class ListItem extends React.Component{

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
    };

    onExportTarget=()=>{
        const {content}=this.props;
        this.setState({loading:true,loadText:"Preparing..."});
        u.autoDownload({
            url:"/api/export-quiz-targets",
            data:{
                quizID:content.quizID
            },
            success:()=>{
                this.setState({loading:false});
            }
        });
    }

    onTargetFile=async (url)=>{
        try{
            const {content}=this.props;
            const response = await u.postAsync({
                url:"/api/quiz-update-targets",
                data:{
                    quizID:content.quizID,
                    filename:url,
                    targetUsers:content.targetUsers
                }
            });
            for(var key in response.data){
                this.props.onChange(response.data[key],key,this.props.index);
            }
            this.setState({step:"target",loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({loading:false,error:error});
        }
    }

    onConfirmNotify=async()=>{
        const {content}=this.props;
        this.setState({loading:true,loadText:"Preparing..."});
        try{
            const response = await u.postAsync({
                url:'/api/quiz-notify-targets',
                data:{
                    quizID:content.quizID,
                    targetUsers:content.targetUsers
                }
            });
            for(var key in response.data){
                this.props.onChange(response.data[key],key,this.props.index);
            }
            this.setState({step:"target",loading:false,error:""});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    render=()=>{
        const {content,settings,permissions,languages} = this.props;
        const canEdit= (permissions.update==2);

        return (
            <div style={{textAlign:"center"}}>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel} 
                                    permission={settings.permission} 
                                    content={content} 
                                    onChange={this.props.onChange} 
                                    index={this.props.index}
                                    />

                    <div style={{margin:"20px auto"}}>
                        <QuestionTable content={content.questions}
                                       languages={languages}
                                       />
                    </div>

                    {
                        (canEdit)   
                            ?
                            <div style={{margin:"20px auto"}}>
                                <Button onClick={()=>{this.props.onCloneEntry(content)}}>Clone Entry</Button>
                            </div>
                            :
                            null
                    }

                    <div style={{margin:"20px auto"}}>
                        <TextButton onClick={()=>{this.setState({step:"target",error:""})}}>See Target User</TextButton>
                    </div>
                </Step>

                <Step active={this.state.step=="target"}>
                    <h2>Target Users</h2>
                    <div style={{marginBottom:"20px"}}>Only the following users can take this quiz</div>
                    <TargetUser content={content.targetUsers}/>
                    <div style={{margin:"30px auto 20px auto"}}>
                        <TextButton onClick={this.onExportTarget}>Export Target</TextButton>
                        <TextButton onClick={()=>{this.setState({step:"upload",error:""})}}>Update Target</TextButton>
                    </div>
                    <div style={{margin:"20px auto"}}>
                        <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        {
                            (content.targetUsers.length > 0)
                                ?
                                <Button onClick={()=>{this.setState({step:"notify",error:""})}}>Notify Target</Button>
                                :
                                null
                        }
                    </div>
                </Step>

                <Step active={this.state.step=="upload"}>
                    <div style={{position:"relative",textAlign:"center"}}>
                        <Dropzone label="dz"
                                  onAdded={()=>{this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onTargetFile}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..."+value+"%"})}}
                                  filetypes={Spreadsheet}
                                  dragAndDropLabel="Download template below. Remove users who are no longer targeted from file"
                                  />
                    </div>
                    <div style={{margin:"20px auto"}}>
                        <div className="page-error">{this.state.error}</div>
                        <Button onClick={()=>{this.setState({step:"target",error:""})}}>Back</Button>
                        <Button onClick={this.onExportTarget}>Download Template</Button>
                    </div>
                </Step>

                <Step active={this.state.step=="notify"}>
                    <div style={{position:"relative",textAlign:"center",padding:"30px 0"}}>
                        <h2 className='text-negative'>Notify All Non-Notified Targets?</h2>
                        <div style={{margin:"20px auto"}}>
                            Note. Mobile app notification to do quiz will be fired to users who have not yet been notified
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"target",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmNotify}>Confirm</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{
    
    settings={
        addType:0,
        addURL:"/api/create-quiz-entry",
    };

    r={};

    questionDefault=[];

    state={
        step:"add",
        entryData:{
            questions:[],
        },
        options:{},
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:"",});

            if(this.emptyQuestion){
                this.setState({
                    entryData:{
                        questions:[JSON.parse(JSON.stringify(this.emptyQuestion))],
                    }
                })
            }
        }
    }

    componentDidMount=()=>{
        this.getOptions();

        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[
                        "eLearningLanguage"
                    ]
                }
            });
            
            let qd = {};
            for(var i=0; i<response.data.eLearningLanguage.length; i++){
                const language = response.data.eLearningLanguage[i].value;
                qd[language]={
                    wrong:["","",""]
                }
            }
            this.languages=response.data.eLearningLanguage.map((item)=>{return item.value});
            this.emptyQuestion=qd;
            let {entryData}=this.state;
            entryData.questions.push(JSON.parse(JSON.stringify(this.emptyQuestion)));
            this.setState({options:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        const {entryData}=this.state;
        const subkeys=["question","correct","wrong1","wrong2","wrong3"];
        for(var i=0; i<entryData.questions.length; i++){
            for(var j=0; j<subkeys.length; j++){
                for(var k=0; k<this.languages.length; k++){
                    const current=this.r[subkeys[j]+"-"+i+"-"+k].validate();
                    if(!current.valid){
                        this.setState({error:current.value});
                        return 0;
                    }
                }
            }
        }
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...entryData,...data});
    }

    onComplete=()=>{
        this.setState({
            entryData:{
                questions:[JSON.parse(JSON.stringify(this.emptyQuestion))],
            },
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onUploadRequest=(indexObj)=>{
        console.log(indexObj);
        this.nextFile=indexObj;
        this.setState({step:"add-attachment",error:""});
    }

    onAddAttachment=(url)=>{
        let entryData=this.state.entryData;
        const indexObj=this.nextFile;
        entryData.questions[indexObj.index][indexObj.language].url=url;
        this.setState({entryData:entryData,step:"add",error:"",loading:false});
    }

    onAddQuestion=()=>{
        let {entryData}=this.state;
        entryData.questions.push(JSON.parse(JSON.stringify(this.emptyQuestion)));
        this.setState({entryData:entryData});
    }

    onRemoveQuestion=(index)=>{
        let {entryData}=this.state;
        entryData.questions.splice(index,1);
        this.setState({entryData:entryData});
    }

    onChangeQuestion=(value,label,indexObj)=>{
        let {entryData}=this.state;
        if(label=="wrong"){
            entryData.questions[indexObj.index][indexObj.language][label][indexObj.wrongIndex]=value;
        }
        else{
            entryData.questions[indexObj.index][indexObj.language][label]=value;
        }
        this.setState({entryData:entryData});
    }

    editEntry=(clone,entryData)=>{
        this.setState({entryData:entryData});
    }

    render=()=>{
        const {loading,loadText,step,options,entryData}=this.state;
        const fields=[
            {dataType:"box",label:"Quiz Reference",field:"reference",rules:{required:true}},
            {dataType:"box",label:"Points Given",field:"pointGiven",rules:{required:true,minValue:"0"},type:"number"},
            {dataType:"box",label:"Passing Score",field:"passingScore",rules:{required:true,placeholder:"Number of qns correctly answered",minValue:0},type:"number"},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         stepScroll={true}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create entry</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                       
                        {
                            entryData.questions.map(
                                (question,qIndex,qarr)=>{
                                    return (
                                        <div key={qIndex} className='list-table' style={{position:"relative",maxHeight:"none",fontSize:"12px",margin:"20px auto",textAlign:"center",width:"1440px",maxWidth:"100%"}}>
                                            <h3 style={{margin:"5px 0"}}>Question {qIndex+1}.</h3>
                                            <div>{(qarr.length > 1) ? <TextButton onClick={()=>{this.onRemoveQuestion(qIndex)}}>Remove Question</TextButton> : null}</div>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th style={{width:"150px"}} className='left'>Language</th>
                                                        <th>Question</th>
                                                        <th style={{width:"150px",textAlign:"center"}}>Q. Image</th>
                                                        <th style={{width:"150px"}}>Correct Answer</th>
                                                        <th style={{width:"150px"}}>Wrong Answer</th>
                                                        <th style={{width:"150px"}}>Wrong Answer</th>
                                                        <th style={{width:"150px"}} className='right'>Wrong Answer</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.languages.map(
                                                            (lang,lIndex)=>{
                                                                return (
                                                                    <tr key={qIndex+"-"+lIndex} className='item'>
                                                                        <td>{lang}</td>
                                                                        <td>
                                                                            <Box ref={(ref)=>{this.r['question-'+qIndex+"-"+lIndex]=ref}}
                                                                                values={{value:question[lang].question}}
                                                                                label={"Question - "+lang}
                                                                                field="question"
                                                                                index={{
                                                                                    index:qIndex,
                                                                                    language:lang
                                                                                }}
                                                                                rules={{required:(lIndex==0),placeholder:(lIndex==0) ? "Default" : ""}}
                                                                                onChange={this.onChangeQuestion}
                                                                                />
                                                                        </td>
                                                                        <td style={{padding:"0 10px",textAlign:"center"}}>
                                                                            {
                                                                                (question[lang].url || question[lang].image)
                                                                                    ?
                                                                                    <img className='quiz-image' onClick={()=>{this.onUploadRequest({index:qIndex,language:lang})}} src={(question[lang].url) ? question[lang].url : question[lang].image} style={{maxWidth:"130px",maxHeight:"30px"}}/>
                                                                                    :
                                                                                    <div><TextButton style={{margin:"10px 0"}} onClick={()=>{this.onUploadRequest({index:qIndex,language:lang})}}>Select File</TextButton></div>
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            <Box ref={(ref)=>{this.r['correct-'+qIndex+"-"+lIndex]=ref}}
                                                                                values={{value:question[lang].correct}}
                                                                                label={"Correct Answer - "+lang}
                                                                                field="correct"
                                                                                index={{
                                                                                    index:qIndex,
                                                                                    language:lang
                                                                                }}
                                                                                rules={{required:(lIndex==0),placeholder:(lIndex==0) ? "Default" : ""}}
                                                                                onChange={this.onChangeQuestion}
                                                                                />
                                                                        </td>
                                                                        <td>
                                                                            <Box ref={(ref)=>{this.r['wrong1-'+qIndex+"-"+lIndex]=ref}}
                                                                                values={{value:question[lang].wrong[0]}}
                                                                                label={"Wrong Answer - "+lang}
                                                                                field="wrong"
                                                                                index={{
                                                                                    index:qIndex,
                                                                                    language:lang,
                                                                                    wrongIndex:0,
                                                                                }}
                                                                                rules={{required:(lIndex==0),placeholder:(lIndex==0) ? "Default" : ""}}
                                                                                onChange={this.onChangeQuestion}
                                                                                />
                                                                        </td>
                                                                        <td>
                                                                            <Box ref={(ref)=>{this.r['wrong2-'+qIndex+"-"+lIndex]=ref}}
                                                                                values={{value:question[lang].wrong[1]}}
                                                                                label={"Wrong Answer - "+lang}
                                                                                field="wrong"
                                                                                index={{
                                                                                    index:qIndex,
                                                                                    language:lang,
                                                                                    wrongIndex:1,
                                                                                }}
                                                                                rules={{required:(lIndex==0),placeholder:(lIndex==0) ? "Default" : ""}}
                                                                                onChange={this.onChangeQuestion}
                                                                                />
                                                                        </td>
                                                                        <td>
                                                                            <Box ref={(ref)=>{this.r['wrong3-'+qIndex+"-"+lIndex]=ref}}
                                                                                values={{value:question[lang].wrong[2]}}
                                                                                label={"Wrong Answer - "+lang}
                                                                                field="wrong"
                                                                                index={{
                                                                                    index:qIndex,
                                                                                    language:lang,
                                                                                    wrongIndex:2,
                                                                                }}
                                                                                rules={{required:(lIndex==0),placeholder:(lIndex==0) ? "Default" : ""}}
                                                                                onChange={this.onChangeQuestion}
                                                                                />
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                }
                            )
                        }
                         

                        <div style={{margin:"20px auto",fontSize:"12px"}}>
                            <TextButton onClick={this.onAddQuestion}>Add Question</TextButton>
                        </div>

                        <div className="segment-note">
                            Note. If an input is left empty, it will be replaced by the Default
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="add-attachment"} scroll={true}>
                        <Dropzone label={"Photo"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddAttachment}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Photo}
                                  />
                        
                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"add",error:""})}}>Back</Button>
                        </div>
                    </Step>
                </div>

            </AddListItem>
        )
    }
}

class QuestionTable extends React.Component{

    state={
        page:1
    }

    onChangePage=(newPage)=>{
        this.setState({page:newPage});
    }

    render=()=>{
        const {content,languages}=this.props;
        const {page}=this.state;
        const maxPage=content.length;
        return (
            <div className='list-table' style={{maxHeight:"none",width:"1440px",maxWidth:"100%"}}>
                <h3>Question {page}.</h3>
                <table>
                    <thead>
                        <tr>
                            <th style={{width:"150px"}} className='left'>Language</th>
                            <th>Question</th>
                            <th style={{width:"150px"}}>Q. Image</th>
                            <th style={{width:"150px"}}>Correct</th>
                            <th style={{width:"150px"}}>Wrong</th>
                            <th style={{width:"150px"}}>Wrong</th>
                            <th style={{width:"150px"}} className='right'>Wrong</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            languages.map(
                                (lang,lIndex)=>{
                                    const entry=content[page-1][lang];
                                    if(typeof entry == "undefined"){
                                        return null;
                                    }
                                    return (
                                        <tr key={lIndex} className='item'>
                                            <td>{(lIndex==0 ? "(Default) " : "")}{lang}</td>
                                            <td>{(entry.question) ? entry.question  : "-"}</td>
                                            <td style={{padding:"5px 10px 0 10px"}}>
                                                {
                                                    (entry.image)
                                                        ?
                                                        <img src={entry.image} style={{maxHeight:"30px",maxWidth:"130px",margin:"0"}} onClick={()=>{window.open(entry.image,"_blank")}}/>
                                                        :
                                                        "-"
                                                }
                                            </td>
                                            <td>{(entry.correct) ? entry.correct  : "-"}</td>
                                            <td>{(entry.wrong[0]) ? entry.wrong[0]  : "-"}</td>
                                            <td>{(entry.wrong[1]) ? entry.wrong[1]  : "-"}</td>
                                            <td>{(entry.wrong[2]) ? entry.wrong[2]  : "-"}</td>
                                        </tr>
                                    )
                                }
                            )
                        }
                    </tbody>
                </table>
                {
                    (maxPage > 1)
                        ?
                        <div style={{margin:"20px auto"}}>
                            <PageSelector maxPage={maxPage}
                                          page={page}
                                          onChange={this.onChangePage}
                                          />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

class TargetUser extends React.Component{

    pageLength=10.0;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
    }
    
    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * parseInt(this.pageLength);
        const endIndex = startIndex + parseInt(this.pageLength);
        this.setState({
            page:newPage,
            startIndex:startIndex,
            endIndex:endIndex
        });
    }

    render=()=>{
        const {content}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(content.length / this.pageLength);
        if(content.length == 0){
            return (
                <div className='list-placeholder'>
                    <b>No Target Users</b>
                    <div>Click below to update target users</div>
                </div>
            )
        }
        return(
            <div className='list-table' style={{maxHeight:"none"}}>
                <table>
                    <thead>
                        <tr>
                            <th className='remove left'/>
                            <th style={{width:"180px"}}>NRIC/FIN</th>
                            <th style={{width:"180px"}}>Type</th>
                            <th>Name</th>
                            <th style={{width:"100px"}} className='right'>Notified</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            content.map(
                                (item,index)=>{
                                    if(index < startIndex || index >= endIndex){
                                        return null;
                                    }
                                    return (
                                        <tr key={index}>
                                            <td>{(index+1)}.</td>
                                            <td>{item.nric}</td>
                                            <td>{item.type}</td>
                                            <td>{item.name}</td>
                                            <td>{(item.notified==true) ? "Yes" : "No"}</td>
                                        </tr>
                                    )
                            })
                        }
                    </tbody>
                </table>

                {
                    (maxPage > 1)
                        ?
                        <div style={{margin:"20px auto"}}>
                            <PageSelector maxPage={maxPage}
                                            page={page}
                                            onChange={this.onChangePage}
                                            />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}
